export const DefaultSetupWizardLoadingFormat = 'setupWizard.wizardIndicator.loading.default';

export const SetupWizardStep = {
  WELCOME_SCREEN: 'welcomeScreen',
  AUTOMATED_ERROR_REPORT: 'automatedErrorReport',
  COLLISION_CALIBRATION: 'collisionCalibration',
  TRAY_CALIBRATION: 'trayCalibration',
  A1_OFFSET_CALIBRATION: 'a1OffsetCalibration',
  TIPS_PICKUP_CALIBRATION: 'tipsPickupCalibration',
  VISION_CALIBRATION: 'visionCalibration',
  PLATE_DEFINITION: 'plateDefinition',
  PLATE_COPY_PROTOCOL: 'plateCopyProtocol',
  REPORT: 'report',
  FINISH_SCREEN: 'finishScreen',
};

export const A1OffsetCalibrationSubstep = {
  GUIDE_IMAGE: 1,
  CHECK_TIP_PICK_UP: 2,
};

export const VisionCalibrationSubstep = {
  SCAN_TIPS: 1,
  SLANTED_TIPS: 2,
  STUCK_TIPS_GUIDE: 3,
  STUCK_TIPS_RESULT: 4,
};

export const PlateDefinitionSubstep = {
  GUIDE_IMAGE: 1,
  WELL_MEASUREMENT: 2,
  SUMMARY: 3,
};

export const PlateCopyProtocolSubstep = {
  GUIDE_IMAGE: 1,
  RUN_PROTOCOL: 2,
};

export const DefaultInstrumentV1StepsData = {
  [SetupWizardStep.A1_OFFSET_CALIBRATION]: {
    totalSubstep: 2,
    isUpdateA1OffsetAllowed: false,
    isSkippable: true,
    isStepProcessed: false,
  },
  [SetupWizardStep.VISION_CALIBRATION]: {
    totalSubstep: 4,
    scanSuccess: false,
    hasScanned: false,
    isSkippable: true,
    isStepProcessed: false,
  },
  [SetupWizardStep.PLATE_DEFINITION]: {totalSubstep: 3, isSkippable: true, isStepProcessed: false},
  [SetupWizardStep.PLATE_COPY_PROTOCOL]: {totalSubstep: 2, isSkippable: true, isStepProcessed: false},
};

export const DefaultInstrumentV2StepsData = {
  ...DefaultInstrumentV1StepsData,
  [SetupWizardStep.A1_OFFSET_CALIBRATION]: {
    totalSubstep: 1,
    isUpdateA1OffsetAllowed: false,
    isSkippable: true,
    isStepProcessed: false,
  },
};

export const WizardStatus = {
  ONGOING: 'ongoing',
  NOT_STARTED: 'notStarted',
  COMPLETED: 'completed',
};

export const WizardFlag = {
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success',
  NONE: 'none',
};
